'use strict';

var u = require('universalify').fromPromise;

var fs = require('../fs');

function pathExists(path) {
  return fs.access(path).then(function () {
    return true;
  }).catch(function () {
    return false;
  });
}

module.exports = {
  pathExists: u(pathExists),
  pathExistsSync: fs.existsSync
};